// extracted by mini-css-extract-plugin
module.exports = {"button__hamburger":"HamburgerButton_button__hamburger__2Fynd","dark":"HamburgerButton_dark__U2k8Y"};